import { createContext, useContext } from 'react';

const BriefIdContext = createContext();

export const BriefIdContextProvider = BriefIdContext.Provider;
export const useBriefIdContext = () => useContext(BriefIdContext);
